module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 64
// module chunks = 0